import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const RoleButton = ({ isSelected, roleId, name, handler }) => {
  const roleBtnClasses = classnames('users-editor-role-btn', { 'users-editor-role-selected': isSelected });

  return (
    <span id={roleId} className={roleBtnClasses} onClick={handler}>
      {name}
    </span>
  );
};

RoleButton.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  roleId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handler: PropTypes.func,
};

export default RoleButton;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/role_button.jsx